import {createStore} from '../alt';
import moment from 'moment';

import {InvalidResponseCode} from '../resources/GenericResource';
import GlobalActions from '../actions/GlobalActions';


const GlobalSource = {
};

class GlobalStore {
    constructor() {
        this.dashboardTab = 'agenda';
        this.activeDashboardDate = null;

        this.exportAsync(GlobalSource);
        this.bindActions(GlobalActions);
    }

    onSaveDashboardTab(dashboardTab) {
        this.setState({dashboardTab});
    }

    onSaveDashboardDate(activeDashboardDate) {
        this.setState({activeDashboardDate});
    }
}

export default createStore(GlobalStore, 'GlobalStore', module);



/** WEBPACK FOOTER **
 ** ./app/src/stores/GlobalStore.js
 **/